import { useMemo } from "react";
import type { NextRouter } from "next/router";
import {
	extractCustomerLoginCustomerUidFromRouter,
	extractCustomerLoginFolderUidFromRouter,
	extractCustomerLoginOfficeUidFromRouter,
} from "@Front/Components/Layouts/Login/helpers/loginFolderUidHelpers";
import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";

export function useLoginRouterScope(router: NextRouter): CustomerLoginRouterScope {
	const loginFolderUid = useMemo(() => extractCustomerLoginFolderUidFromRouter(router), [router]);
	const loginOfficeUid = useMemo(() => extractCustomerLoginOfficeUidFromRouter(router), [router]);
	const loginCustomerUid = useMemo(() => extractCustomerLoginCustomerUidFromRouter(router), [router]);
	return { loginFolderUid, loginOfficeUid, loginCustomerUid };
}
